import React from 'react'
import './Card.css';
import './Card2.css';
const Card2 = ({image,image2,desc}) => {
  return (
  <>
   <div className='card'>
        <img src={image} alt=""  className='card2-img'/>
        <img src={image2} alt=""  className='card2-title'/>
        
        <div className="card-hover-content1">
            <p className=" card-description2">{desc}</p>
        </div>
   </div>
   
  </>
  )
}

export default Card2;